import React, { Component, Suspense } from "react"
import { Container, Row, Col } from "reactstrap"
import { withTranslation } from "react-i18next"
import LazyLoad from 'react-lazy-load'
import i18n from "i18next"
import "react-lazy-load-image-component/src/effects/opacity.css"
import { Parallax } from "react-scroll-parallax"
import MetagenomiqueViePrivee from "../components/home/metagenomique-vie-privee.jsx"
import MicrobioteIntestinal from "../components/home/microbiote-intestinal.jsx"
import NahibuHelmet from "../components/nahibu-helmet"
import DecouvrezMicrobioteIntestinal from "../components/home/decouvrez-microbiote-intestinal.jsx"
import CommentTestezSonMicrobiote from "../components/home/comment-testez-son-microbiote.jsx"
import LienEntreMicrobioteEtSante from "../components/home/lien-entre-microbiote-et-sante.jsx"
import ResultatsFiableComplet from "../components/home/resultats-fiable-complet.jsx"
import FormFAQ from "../components/home/form-FAQ.jsx"
import Reassurance from "../components/home/reassurance-blue.jsx"
import character_1 from "../images/characters/character_1.png"
const BuyDiv = React.lazy(() => import('../components/buydiv'))

const NahibuVideo = () => (
  <Parallax x={[3, 3]} tagOuter="figure">
    <div className="responsive-video">
      <LazyLoad debounce={false}>
        <iframe
          loading="lazy"
          src="https://www.youtube.com/embed/V2nf-nGnehg"
          title="YouTube video Nahibu"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </LazyLoad>
    </div>
  </Parallax>
)

const benefits = [
  "home|Comprendre l’origine de vos troubles digestifs",
  "home|Agir de façon ciblée grâce à des recommandations personnalisées",
  "home|Prévenir des déséquilibres futurs et améliorer votre bien-être",
]

class Home extends Component {
  render() {
    const t = this.props.t
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""

    return (
      <>
        <NahibuHelmet
          canonicalUrl={'https://nahibu.me' + langSubPath + '/' + t('canonical-url|microbiote-intestinal') + '/'}
          title={t("microbiota|Analyse Microbiote Intestinal – Kit Test Personnalisé & Résultats Clairs") + " | Nahibu"}
          description={t("microbiota|Le microbiote intestinal est constitué de micro-organismes comme les bactéries, champignons et virus, résidant dans l’intestin. Il joue un rôle fonctionnel et contribue à notre bien-être.")}
        />

        <Container fluid className="bg-image-main px-3 pb-5">
          <Container fluid className="mx-0 px-0 px-md-5">
            <Row className="align-items-center">
              <Col className="text-center text-md-start d-none d-md-block pr-4 order-md-1" md={2}>
                <img className="ml-3" alt={t("buy|Kit d'analyse du microbiote intestinal Nahibu")} src={character_1} width="120px" />
              </Col>

              <Col className="order-2 order-md-2 mt-4 mt-md-0 pl-3 pl-md-5 shadow-text" md={4}>
                <h1 className="pt-0 pt-md-3 mb-4 pt-md-0 text-left">
                  <div className="white h1-override pt-0 pt-md-4">{t("home|Analysez")}</div>
                  <div className="white h2-override" style={{ lineHeight: "0.92" }}>{t("home|votre microbiote intestinal avec le kit Nahibu")}</div>
                </h1>

                <div className="d-block d-md-none order-3">
                  <NahibuVideo />
                </div>

                <div className="d-none d-md-block ">
                  <p className="white h3-override pt-1 pt-md-0 lh-1 text-left underline">
                    {t("home|Pourquoi analyser votre microbiote ?")}
                  </p>
                  <ul className="pt-0 pt-md-3 pb-5 mb-5 ml-0 ml-md-5 text-left list-unstyled">
                    {benefits.map((key, index) => (
                      <li key={index} className="d-flex align-items-start mb-2 mb-md-3">
                        <span className="white mr-2">✔</span>
                        <span className="white">{t(key)}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>

              <Col className="order-1 order-md-2 text-center d-none d-md-block" md={6}>
                <NahibuVideo />
              </Col>
            </Row>
          </Container>
        </Container>

        <MicrobioteIntestinal />
        <CommentTestezSonMicrobiote />
        <MetagenomiqueViePrivee />
        <ResultatsFiableComplet />
        <DecouvrezMicrobioteIntestinal />
        <LienEntreMicrobioteEtSante />
        <FormFAQ />
        <Reassurance />

        <Suspense fallback={<div></div>}>
          <BuyDiv />
        </Suspense>
      </>
    )
  }
}

export default withTranslation()(Home)